import type { SpareCandidate } from './types'

/**
 * The candidates the Player Finder lists for a game: the server's eligibility
 * list, minus anyone already asked for this game or already on its roster.
 * Once asked, a player is followed up on the attendance screen (Eligible Game
 * Spares / Roster Spares), not here — so an ask takes them off the finder.
 */
export const withoutAskedOrRosterPlayers = (
  candidates: readonly SpareCandidate[],
  gameRosterPlayerIds: Iterable<string>
): SpareCandidate[] => {
  const onRoster = new Set(gameRosterPlayerIds)

  return candidates.filter(
    (candidate) => !candidate.request && !onRoster.has(candidate.id)
  )
}
